import { lazy, Suspense } from "react";

const Calendar = lazy(() =>
  import("@/components/ui/calendar").then((m) => ({ default: m.Calendar })),
);

export function LazyCalendar(props: React.ComponentProps<typeof Calendar>) {
  return (
    <Suspense fallback={<div className="p-6 text-sm text-muted-foreground">Ładowanie kalendarza…</div>}>
      <Calendar {...props} />
    </Suspense>
  );
}
